var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('h3',[_vm._v("404 error")]),_c('h4',[_vm._v("...redirecting...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }